




















































import { Component, Vue } from 'vue-property-decorator';

import { eventBus } from '@/main';
import { APP_CONFIG } from '@/config/app-config';
import { NotificationModel } from '@/models/notification';
import orderService from '@/services/order-service';
import commonServices from '@/services/common-services';

@Component({})
export default class Notification extends Vue {
    private eventEmit = {
        totalNotification: 'totalNotification'
    };
    private tab = {
        noti: 'noti',
        msg: 'msg'
    }
    private timer: any;
    private selectedTab = this.tab.noti;
    private pageSettings = {
        rowPerPage: 10,
        pageSize: 3,
        pageIndex: 1,
        total: 0,
    };
    private listNotification: NotificationModel[] = [];
    private top5Notifications = {
        global_total: 0,
        public_total: 0,
        global_items: [],
        public_items: []
    };
    private isLoading = false;
    private onSelectedTab(tab: any) {
        this.selectedTab = tab;
    }
    private closePopup() {
      // Tìm dropdown và trigger sự kiện đóng
      const dropdown = document.querySelector('.headermenu div.btn-group.open');
      if (dropdown) {
        dropdown.classList.remove("open");
      }
    }
    private async created() {
        this.timer = setInterval(() => {
            this.loadNotification();
        }, APP_CONFIG.notifyRefreshTime * 1000);

        eventBus.$on(APP_CONFIG.eventBusAction.reloadNotification, () => {
            this.loadNotification();
        });

        this.loadNotification();
    }

    private async destroyed() {
        clearInterval(this.timer);
    }

    private async loadNotification() {
        if(document.hidden) {
            return;
        }
        this.listNotification = [];
        this.isLoading = true;
        const filter = [{ column: 'Status', value: [0,2], condition: 'in' }];
        const result = await commonServices.getNotification(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filter, true);
        if (result && result.status === 200 && result.data.status === 200) {
            this.top5Notifications = result.data.data;
            if(this.listNotification.length > 0) {
                this.$emit(this.eventEmit.totalNotification, {global_total: 0, public_total: 0});
            } else {
                this.$emit(this.eventEmit.totalNotification, {global_total: this.top5Notifications.global_total, public_total: this.top5Notifications.public_total});
            }
            
        }
        this.isLoading = false;
    }

    private async handleScroll(event: any) {
        // const scrollHeight = event.target.scrollHeight;
        // const scrollPosition = event.target.scrollTop;
        // if (scrollPosition > scrollHeight - 350) {
        //     this.pageSettings.pageIndex++;
        //     this.loadNotification();
        // }
    }

    private async onReadNotification(notif: any) {
        try {
            commonServices.updateStatusNotification(notif.ID, { Status: 1 }).then(result  => {
                if (result && result.status === 200 && result.data.status === 200) {
                    this.loadNotification();
                }
            });
            if(!notif.OrderID) {
                return;
            }
            if (notif.OrderType == APP_CONFIG.ORDER_TYPE.deposit) {
                this.$router.push({ name: 'deposit-detail', params: { id: notif.OrderID.toString() } }).catch(() => {
                    return false;
                });
            } else if(notif.OrderType == 6) {
                this.$router.push({ name: 'payauthority-detail', params: { id: notif.OrderID.toString() } }).catch(() => {
                    return false;
                });
            } else if(notif.OrderType == 5) {
                this.$router.push({ name: 'payservice-detail', params: { id: notif.OrderID.toString() } }).catch(() => {
                    return false;
                });
            } else if(notif.OrderType == 4) {
                const result = await orderService.getComplainById(notif.OrderID);
                if (result && result.status === 200 && result.data.status === 200) {
                    let complain = result.data.data;
                    if(complain.OrderType == 1) {
                        this.$router.push({ name: 'detail-order-complain', params: { orderId: complain.OrderID, complainId: complain.ID, orderType: complain.OrderType } });
                    }
                    else if (complain.orderType == 2) {
                        this.$router.push({ name: 'detail-deposit-complain', params: { orderId: complain.OrderID, complainId: complain.ID, orderType: complain.OrderType } });
                    }
                    else if(complain.orderType == 3) {
                        this.$router.push({ name: 'detail-deposit-complain', params: { orderId: complain.OrderID, complainId: complain.ID, orderType: complain.OrderType } });
                    }
                }
            } else {
                this.$router.push({ name: 'order-detail', params: { orderId: notif.OrderID.toString() } }).catch(() => {
                    return false;
                });
            }
        } catch {
            return false;
        }
    }
}
